import { defineMessages } from 'react-intl';

const messages: {
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spaceLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	startDateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	releaseDateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	asEarlyAsPossible: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noReleaseDate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cardTitle: {
		id: 'conversation-assistant-message-actions.create-release.card-title',
		defaultMessage: 'Create plan release',
		description: 'Title for the create plan release action card',
	},
	spaceLabel: {
		id: 'conversation-assistant-message-actions.create-release.space-label',
		defaultMessage: 'Space',
		description: 'Label for the space field in the create release form',
	},
	startDateLabel: {
		id: 'conversation-assistant-message-actions.create-release.start-date-label',
		defaultMessage: 'Start date',
		description:
			'Label shown next to the start date input field in the create release dialog for Jira Plans',
	},
	releaseDateLabel: {
		id: 'conversation-assistant-message-actions.create-release.release-date-label',
		defaultMessage: 'Release date',
		description:
			'Label shown next to the release date input field in the create release dialog for Jira Plans, indicating the target release date',
	},
	asEarlyAsPossible: {
		id: 'conversation-assistant-message-actions.create-release.as-early-as-possible',
		defaultMessage: 'As early as possible',
		description: 'Fallback text when no start date is provided',
	},
	noReleaseDate: {
		id: 'conversation-assistant-message-actions.create-release.no-release-date',
		defaultMessage: 'No release date',
		description: 'Fallback text when no release date is provided',
	},
	confirmButton: {
		id: 'conversation-assistant-message-actions.create-release.confirm-button',
		defaultMessage: 'Create',
		description:
			'Text on the confirm button in the create release dialog for Jira Plans. Clicking it submits the form and creates the new plan release',
	},
	cancelButton: {
		id: 'conversation-assistant-message-actions.create-release.cancel-button',
		defaultMessage: 'Cancel',
		description:
			'Text on the cancel button in the create release dialog for Jira Plans. Dismisses the dialog without saving changes',
	},
});

export default messages;
